import { render, staticRenderFns } from "./userCourse.vue?vue&type=template&id=55374f26&scoped=true"
import script from "./userCourse.vue?vue&type=script&lang=js"
export * from "./userCourse.vue?vue&type=script&lang=js"
import style0 from "./userCourse.vue?vue&type=style&index=0&id=55374f26&prod&lang=scss"
import style1 from "./userCourse.vue?vue&type=style&index=1&id=55374f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55374f26",
  null
  
)

export default component.exports